<template>
    <div class="onboarding-review">
        <Nav />
        <div class="pt-5 mt-5 onboarding-width">
            <div class="mt-5 p-4 border add-rounded mx-3 mx-md-5">
                <div class="control-width mx-auto">
                    <h4 class="mb-4 font-weight-bold text-capitalize kova-text">Let's go ahead and make a job post for you</h4>   
                    <h6 class="mb-3 font-weight-bold">What stage is your project?</h6>            
                    <div class="container-fluid px-0 px-md-4 mb-5">
                        <div class="row my-5">
                            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                                <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedFreelanceJob">
                                    <h6 class="kova-text font-weight-bolder mx-auto">Freelance Project</h6>
                                    <font-awesome-icon icon="check-circle" class="checked" v-if="freelance"></font-awesome-icon>
                                </div>
                            </div>
                            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                                <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedCrowdsourceJob">
                                    <h6 class="kova-text font-weight-bolder mx-auto">Crowdsource Project</h6>
                                    <font-awesome-icon icon="check-circle" class="checked" v-if="crowdsource"></font-awesome-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Provide project description below</h4>
                    <h6 class="mb-3 font-weight-bold text-left mt-4">Project name</h6>

                    <a-input size="large" placeholder="e.g. Build me web application" class="mx-auto mb-3" v-model="title" />   
                    <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="description" placeholder="Project Descriptions..." @change="handleChange" required></vue-editor>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bolder kova-text">What Tech-stack requirement do you want your dev to have?</h4>            
                    <a-select
                        mode="multiple" class="w-100 mt-4 mb-5" @change="handleChange" size="large" v-model="stacks" placeholder="What skills are required">
                        <a-select-option v-for="stacklist in stacklists" :key="stacklist"
                        >{{stacklist}}</a-select-option
                        >
                    </a-select>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-4 font-weight-bold kova-text"> Do you have product specifications ready?</h4>
                    <div class="text-left">
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" value="System/Product requirement specifications (SRS) document" v-model="specifications" @change="handleChange" />
                            <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 mb-3 input-title">System/Product requirement specifications (SRS) document</span>
                        </label><br />
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" value="Wireframes" v-model="specifications" @change="handleChange" />
                            <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">Wireframes</span>
                        </label><br />
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" value="UI/UX prototype" v-model="specifications" @change="handleChange" />
                            <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">UI/UX prototype</span>
                        </label><br />
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" value="No,only have idea what I want to build" v-model="specifications" @change="handleChange" />
                            <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">No, only have idea what I want to build</span>
                        </label><br />


                         <h6 class="mb-3 font-weight-bold text-left mt-4">Link to Document</h6>

                            <a-input
                                size="large"
                                placeholder="Google drive Link to product's document"
                                v-model="document_link"
                                class="mx-auto mb-3"
                            />

                     <!--    <a-upload-dragger
                            name="file"
                            :multiple="true"
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                            @change="handleChange"
                        >
                            <p class="ant-upload-drag-icon">
                            <a-icon type="upload" />
                            </p>
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                         
                            </p>
                        </a-upload-dragger> -->
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">How many hours of commitment will you require from your developer?</h4> 
                    <div class="text-left">
                        <label for="opt1" class="radio text-left">
                            <input type="radio" name="rdo" id="opt1" class="hidden" value="40 or more hrs/week (Full time)" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>40 or more hrs/week (Full time)
                        </label><br />

                        <label for="opt2" class="radio text-left">
                            <input type="radio" name="rdo" id="opt2" class="hidden" value="Less than 40 hrs/week (Part time)" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Less than 40 hrs/week (Part time)
                        </label><br />

                        <label for="opt3" class="radio text-left">
                            <input type="radio" name="rdo" id="opt3" class="hidden" value="Hourly" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Hourly
                        </label><br />

                        <label for="opt4" class="radio text-left">
                            <input type="radio" name="rdo" id="opt4" class="hidden" value="Don't know yet" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Don't know yet
                        </label><br />
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Select Job Type</h4> 
                    <div class="text-left">
                        <label for="job1" class="radio text-left">
                            <input type="radio" name="rdo1" id="job1" class="hidden" value="New Project" v-model="fcProject" @change="handleChange" />
                            <span class="label"></span>New Project
                        </label><br />

                        <label for="job2" class="radio text-left">
                            <input type="radio" name="rdo1" id="job2" class="hidden" value="Ongoing Project" v-model="fcProject" @change="handleChange" />
                            <span class="label"></span>Ongoing Project
                        </label><br />

                        <label for="job3" class="radio text-left">
                            <input type="radio" name="rdo1" id="job3" class="hidden" value="Code Refactoring/Debugging" v-model="fcProject" @change="handleChange" />
                            <span class="label"></span>Code Refactoring/Debugging
                        </label><br />
                    </div> 
                </div>
                <hr />
                
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">How long do you need the developer to work on your project?</h4>
                    <div class="text-left">
                        <label for="dur1" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur1" class="hidden" value="Few hours" v-model="duration" @change="handleChange" />
                            <span class="label"></span>Few hours
                        </label><br />
                        
                        <label for="dur2" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur2" class="hidden" value="2 to 5 days" v-model="duration" @change="handleChange"  />
                            <span class="label"></span>2 to 5 days
                        </label><br />
                        
                        <label for="dur3" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur3" class="hidden" value="2 to 4 weeks" v-model="duration" @change="handleChange" />
                            <span class="label"></span>2 to 4 weeks
                        </label><br />

                        <label for="dur4" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur4" class="hidden" value="1 to 2 months" v-model="duration" @change="handleChange" />
                            <span class="label"></span>1 to 2 months
                        </label><br />
                    
                        
                        <label for="dur6" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur6" class="hidden" value="Don't know yet" v-model="duration" @change="handleChange"/>
                            <span class="label"></span>Don't know yet
                        </label><br />
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">How many developers are you hiring?</h4>
                   <div class="text-left">
                        <label for="opt1" class="radio text-left">
                            <input type="radio" name="rdo" id="opt1" class="hidden" value="1" v-model="talent_size" @change="handleChange" />
                            <span class="label"></span>One Developer
                        </label><br />
                        
                        <label for="opt2" class="radio text-left">
                            <input type="radio" name="rdo" id="opt2" class="hidden" value="2" v-model="talent_size" @change="devNoChange" />
                            <span class="label"></span>More than one
                        </label><br />
                        
                        <label for="opt3" class="radio text-left">
                            <input type="radio" name="rdo" id="opt3" class="hidden" value="3" v-model="talent_size" @change="handleChange" />
                            <span class="label"></span>Don't know yet
                        </label><br />
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Select expert level</h4>
                    <div class="text-left">
                        <label for="bud1" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud1" class="hidden" value="$10 - $20/hr (Junior)" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>$10 - $20/hr (Junior)
                        </label><br />
                        
                        <label for="bud2" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud2" class="hidden" value="$15 - $40/hr (Intermediate)" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>$15 - $40/hr (Intermediate)
                        </label><br />

                        <label for="bud3" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud3" class="hidden" value="$25- $60/hr (Senior)" v-model="expertLevel" @change="handleChange"/>
                            <span class="label"></span>$25- $60/hr (Senior)
                        </label><br />

                        <label for="bud4" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud4" class="hidden" value="Fixed price per month?" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>Fixed price per month?
                        </label>
                        <div class="ml-5" v-if="showInput">
                        State it:  <input type="number" class="input" placeholder="1000"/>
                        </div>
                    </div> 
                </div>
                <hr />

                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">State your budget for this project</h4>
                 
                     <h6 class="mb-3 font-weight-bold text-left mt-4">Budget amount</h6>

                      <a-input-number
                        id="inputNumber"
                        v-model="budgetAmount"
                        :precision="number"
                        size="large"
                        placeholder="500 , 1000"
                        class="w-100 mb-3"
                        />
                        <br />

                        <h6 class="mb-3 font-weight-bold text-left mt-4">Currency</h6>

                        <a-select
                        mode="single"
                        class="w-100"
                        size="large"
                        placeholder="Please select your Currency"
                       v-model="budgetCurrency"
                        >
                        <a-select-option v-for="item in currencies" :key="item">
                            {{
                            item
                            }}
                        </a-select-option>
                        </a-select>
                    <br />
                    <br />
                   <!--  <div class="text-left">
                        <label for="bud1" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud1" class="hidden" value="$10 - $20/hr (Junior)" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>$10 - $20/hr (Junior)
                        </label><br />
                        
                        <label for="bud2" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud2" class="hidden" value="$15 - $40/hr (Intermediate)" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>$15 - $40/hr (Intermediate)
                        </label><br />

                        <label for="bud3" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud3" class="hidden" value="$25- $60/hr (Senior)" v-model="expertLevel" @change="handleChange"/>
                            <span class="label"></span>$25- $60/hr (Senior)
                        </label><br />

                        <label for="bud4" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud4" class="hidden" value="Fixed price per month?" v-model="expertLevel" @change="handleChange" />
                            <span class="label"></span>Fixed price per month?
                        </label>
                        <div class="ml-5" v-if="showInput">
                        State it:  <input type="number" class="input" placeholder="1000"/>
                        </div>
                    </div>  -->
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <!-- <h4 class="mb-3 font-weight-bold kova-text">Let's go ahead and make a job post for you</h4> -->
                    <h6 class="font-weight-bold mb-4 text-left">Write a detailed task description of what developer(s) will build</h6> 
                     <a-textarea
          placeholder="Job description here"
          class="m-auto w-100"
          v-model="taskDescription"
          :rows="4"
        />
                    <!-- <a-input size="large" class="m-auto w-100" placeholder="Job description here" /> -->
                    <h6 class="font-weight-bold mb-4 mt-5 text-left">select skill(s) you require from your developer</h6>          

                    <a-select
          mode="multiple"
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="skills"
          placeholder="What skills are required"
        >
          <a-select-option v-for="devskill in devskills" :key="devskill">{{devskill}}</a-select-option>
        </a-select>     
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Bio</h4> 
                       <h6 class="mb-3 font-weight-bold text-left mt-4">Full name</h6>

        <a-input size="large" placeholder="John Doe" v-model="fullName" class="mx-auto mb-3" />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Phone number</h6>

        <a-input size="large" v-model="phone" placeholder class="mx-auto mb-3" />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Location</h6>

        <a-input size="large" v-model="location" placeholder="City, Country" class="mx-auto mb-3" />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Timezone</h6>

        <a-input size="large" v-model="timezone" placeholder="e.g GMT +1" class="mx-auto mb-3" />
        <br />
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Add Location</h4> 
                    <a-select 
                   class="w-100 mt-4" v-model="location" size="large" placeholder="Please select your Country">
                        <a-select-option v-for="item in countries" :key="item"
                        >{{item}}</a-select-option>
                    </a-select>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Language</h4>
                    <a-select mode="multiple" class="w-100 mt-4" size="large" placeholder="Please select your Language" v-model="languages" >
                        <a-select-option v-for="languagelist in languagelists" :key="languagelist"
                        >{{languagelist}}</a-select-option>
                    </a-select>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Visibility</h4>
                    <div class="d-flex flex-wrap text-left">
                        <div class="pl-4 py-1" style="min-width: 200px" :key="visibility">
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="1" v-model="visibilityStatus"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">{{visibility}}</span>
                            </label>
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="2" v-model="visibilityStatus"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">{{visibility}}</span>
                            </label>
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="3" v-model="visibilityStatus"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">{{visibility}}</span>
                            </label>
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="4" v-model="visibilityStatus"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">{{visibility}}</span>
                            </label>
                        </div>
                    </div> 

        <br />
        <br />
          
               <div class="" style="display: inline-block">
                    <label class="checkbox-label">
                        <input type="checkbox"/>
                        <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2"></span>
                    </label> 
                    <p class="text-left">By registering you conﬁrm that you accept the <span class="font-weight-bolder">Terms and Conditions</span> and <span class="font-weight-bolder">Privacy Policy</span></p>
               </div>
            
                    <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Cancel </button>
                            </div>
                            <div class="col text-right">
                                <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" @click="postProject"> {{ this.$route.query.edit ? 'Save' :'Post My Job' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="control-width mx-auto">
                </div>
                <hr /> -->
            </div>

          
        </div>
    </div>
</template>

<script>

import Nav from '@/components/Nav.vue'
import { VueEditor } from "vue2-editor";

export default {
    name: 'onboarding-review',
    components: {
        Nav,
        VueEditor
    },
    data(){
        return {
            stacklists: [
                'PHP', 'Nodejs', 'Django', 'Flask', 'Laravel', 'Java', 'C#', 'C++', '.NET', 
                'Ruby', 'Scala', 'Perl', 'Symfony', 'Spring', 'JSF', 'Others'
            ],
           countries: [
                "Afghanistan",
                "Albania",
                "Algeria",
                "American Samoa",
                "Andorra",
                "Angola",
                "Anguilla",
                "Antarctica",
                "Antigua and Barbuda",
                "Argentina",
                "Armenia",
                "Aruba",
                "Australia",
                "Austria",
                "Azerbaijan",
                "Bahamas (the)",
                "Bahrain",
                "Bangladesh",
                "Barbados",
                "Belarus",
                "Belgium",
                "Belize",
                "Benin",
                "Bermuda",
                "Bhutan",
                "Bolivia (Plurinational State of)",
                "Bonaire, Sint Eustatius and Saba",
                "Bosnia and Herzegovina",
                "Botswana",
                "Bouvet Island",
                "Brazil",
                "British Indian Ocean Territory (the)",
                "Brunei Darussalam",
                "Bulgaria",
                "Burkina Faso",
                "Burundi",
                "Cabo Verde",
                "Cambodia",
                "Cameroon",
                "Canada",
                "Cayman Islands (the)",
                "Central African Republic (the)",
                "Chad",
                "Chile",
                "China",
                "Christmas Island",
                "Cocos (Keeling) Islands (the)",
                "Colombia",
                "Comoros (the)",
                "Congo (the Democratic Republic of the)",
                "Congo (the)",
                "Cook Islands (the)",
                "Costa Rica",
                "Croatia",
                "Cuba",
                "Curaçao",
                "Cyprus",
                "Czechia",
                "Côte d'Ivoire",
                "Denmark",
                "Djibouti",
                "Dominica",
                "Dominican Republic (the)",
                "Ecuador",
                "Egypt",
                "El Salvador",
                "Equatorial Guinea",
                "Eritrea",
                "Estonia",
                "Eswatini",
                "Ethiopia",
                "Falkland Islands (the) [Malvinas]",
                "Faroe Islands (the)",
                "Fiji",
                "Finland",
                "France",
                "French Guiana",
                "French Polynesia",
                "French Southern Territories (the)",
                "Gabon",
                "Gambia (the)",
                "Georgia",
                "Germany",
                "Ghana",
                "Gibraltar",
                "Greece",
                "Greenland",
                "Grenada",
                "Guadeloupe",
                "Guam",
                "Guatemala",
                "Guernsey",
                "Guinea",
                "Guinea-Bissau",
                "Guyana",
                "Haiti",
                "Heard Island and McDonald Islands",
                "Holy See (the)",
                "Honduras",
                "Hong Kong",
                "Hungary",
                "Iceland",
                "India",
                "Indonesia",
                "Iran (Islamic Republic of)",
                "Iraq",
                "Ireland",
                "Isle of Man",
                "Israel",
                "Italy",
                "Jamaica",
                "Japan",
                "Jersey",
                "Jordan",
                "Kazakhstan",
                "Kenya",
                "Kiribati",
                "Korea (the Democratic People's Republic of)",
                "Korea (the Republic of)",
                "Kuwait",
                "Kyrgyzstan",
                "Lao People's Democratic Republic (the)",
                "Latvia",
                "Lebanon",
                "Lesotho",
                "Liberia",
                "Libya",
                "Liechtenstein",
                "Lithuania",
                "Luxembourg",
                "Macao",
                "Madagascar",
                "Malawi",
                "Malaysia",
                "Maldives",
                "Mali",
                "Malta",
                "Marshall Islands (the)",
                "Martinique",
                "Mauritania",
                "Mauritius",
                "Mayotte",
                "Mexico",
                "Micronesia (Federated States of)",
                "Moldova (the Republic of)",
                "Monaco",
                "Mongolia",
                "Montenegro",
                "Montserrat",
                "Morocco",
                "Mozambique",
                "Myanmar",
                "Namibia",
                "Nauru",
                "Nepal",
                "Netherlands (the)",
                "New Caledonia",
                "New Zealand",
                "Nicaragua",
                "Niger (the)",
                "Nigeria",
                "Niue",
                "Norfolk Island",
                "Northern Mariana Islands (the)",
                "Norway",
                "Oman",
                "Pakistan",
                "Palau",
                "Palestine, State of",
                "Panama",
                "Papua New Guinea",
                "Paraguay",
                "Peru",
                "Philippines (the)",
                "Pitcairn",
                "Poland",
                "Portugal",
                "Puerto Rico",
                "Qatar",
                "Republic of North Macedonia",
                "Romania",
                "Russian Federation (the)",
                "Rwanda",
                "Réunion",
                "Saint Barthélemy",
                "Saint Helena, Ascension and Tristan da Cunha",
                "Saint Kitts and Nevis",
                "Saint Lucia",
                "Saint Martin (French part)",
                "Saint Pierre and Miquelon",
                "Saint Vincent and the Grenadines",
                "Samoa",
                "San Marino",
                "Sao Tome and Principe",
                "Saudi Arabia",
                "Senegal",
                "Serbia",
                "Seychelles",
                "Sierra Leone",
                "Singapore",
                "Sint Maarten (Dutch part)",
                "Slovakia",
                "Slovenia",
                "Solomon Islands",
                "Somalia",
                "South Africa",
                "South Georgia and the South Sandwich Islands",
                "South Sudan",
                "Spain",
                "Sri Lanka",
                "Sudan (the)",
                "Suriname",
                "Svalbard and Jan Mayen",
                "Sweden",
                "Switzerland",
                "Syrian Arab Republic",
                "Taiwan",
                "Tajikistan",
                "Tanzania, United Republic of",
                "Thailand",
                "Timor-Leste",
                "Togo",
                "Tokelau",
                "Tonga",
                "Trinidad and Tobago",
                "Tunisia",
                "Turkey",
                "Turkmenistan",
                "Turks and Caicos Islands (the)",
                "Tuvalu",
                "Uganda",
                "Ukraine",
                "United Arab Emirates (the)",
                "United Kingdom of Great Britain and Northern Ireland (the)",
                "United States Minor Outlying Islands (the)",
                "United States of America (the)",
                "Uruguay",
                "Uzbekistan",
                "Vanuatu",
                "Venezuela (Bolivarian Republic of)",
                "Viet Nam",
                "Virgin Islands (British)",
                "Virgin Islands (U.S.)",
                "Wallis and Futuna",
                "Western Sahara",
                "Yemen",
                "Zambia",
                "Zimbabwe"
          ],
            showInput: false,
            error: "",
            response: "",
            devskills: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
            languagelists: ["English", "French"],
            currencies: ["USD", "NGN", "GBP"],
            languages: [],
            visibilityStatus: [],
            visibilities: ['Visible to everyone', 'Only Senior Developers', 'Only Intermediate Developers', 'Only Junior Developers'],
            budgetAmount: this.$store.state.client.clientData.budgetAmount,
            budgetCurrency: this.$store.state.client.clientData.budgetCurrency,
            stacks: this.$store.state.client.clientData.stacks,
            talent_size: this.$store.state.client.clientData.talent_size,
            skills: this.$store.state.client.clientData.skills,
            duration: this.$store.state.client.clientData.duration,
            fixedPrice: this.$store.state.client.clientData.fixedPrice,
            fullName: this.$store.state.client.clientData.fullName,
            commitment: this.$store.state.client.clientData.hoursOfCommitment,
            description	: this.$store.state.client.clientData.description,
            freelance: this.$store.state.client.clientData.jobtype === 'Freelance' ? true : false ,
            crowdsource: this.$store.state.client.clientData.jobtype === 'Crowdsource' ? true : false,
            country: this.$store.state.client.clientData.country,
            location: this.$store.state.client.clientData.location,
            phone: this.$store.state.client.clientData.phone,
            expertLevel : this.$store.state.client.clientData.price,
            title: this.$store.state.client.clientData.title,
            taskDescription: this.$store.state.client.clientData.taskDescription,
            timezone: this.$store.state.client.clientData.timezone,
            specifications: this.$store.state.client.clientData.specifications,
            document_link: this.$store.state.client.clientData.document_link,
            fcProject: this.$store.state.client.clientData.fcProject
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('payment-budget')
        },
        skip(){
            this.$router.push('onboarding/description')
        },
        clickedFreelanceJob(){
            this.freelanceJob = true;
            this.crowdsourceJob = false;
            let projectState = this.freelanceJob ? 'Freelance' : this.crowdsourceJob ? 'Crowdsource' : '';
            this.$store.state.client.clientData.jobtype = projectState
        },
        clickedCrowdsourceJob(){
            this.crowdsourceJob = true;
            this.freelanceJob = false;
            let projectState = this.crowdsourceJob ? 'Crowdsource' : this.freelanceJob ? 'Freelance' : '';
            this.$store.state.client.clientData.jobtype = projectState
        },
        devNoChange(e){
            if(e.target.value === "more"){
                return this.showInput = true;
            }
            return this.showInput = false;
        },
        handleChange(){
            this.$store.state.projects.title = this.title;
            this.$store.state.projects.description = this.htmlForEditor;
            this.$store.state.projects.skills = this.skill;
            this.$store.state.projects.specifications = this.specifications;
            this.$store.state.projects.commitment = this.commitment;
            this.$store.state.projects.jobType = this.jobType;
            this.$store.state.projects.duration = this.duration;
            this.$store.state.projects.talent_size = this.talentSize;
            this.$store.state.projects.complexity = this.complexity;
            this.$store.state.projects.devSkills = this.devSkills
        },
        postProject(){
            const projectData = {
                title: this.$store.state.projects.title,
                description: this.$store.state.projects.description,
                talent_size: Number(this.$store.state.projects.talent_size),
                skills: this.$store.state.projects.skills,
                duration: Number(this.$store.state.projects.duration),
                commitment: Number(this.$store.state.projects.commitment),
                complexity: Number(this.$store.state.projects.complexity),
                start_budget: Number(this.$store.state.projects.start_budget),
                end_budget: Number(this.$store.state.projects.end_budget),
            }

           
            if(this.$route.query.edit){
                this.$store.dispatch('projects/updateProject', { projectData: projectData, projectId: this.$route.query.projectId })
                .then(resp => {
                   this.response = resp
                    this.$router.push("my-projects")
                })
                .catch(err => {
                    this.error = err
                })
            } else {
                this.$store.dispatch('projects/postProject', projectData )
                .then(resp => {
                   this.response = resp;
                    this.$router.push("my-projects")
                })
                .catch(err => {
                 this.error = err;
                })
            }
            
        }
    },
    mounted(){
        this.$http({
            method: 'GET',
            url:'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
            headers: {
                "x-rapidapi-host": "ajayakv-rest-countries-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
            }
        }).then((response) => {
            this.countries = response.data
            // console.log(response.data)
        });
    }
}
</script>

<style scoped>
.onboarding-width{
   max-width: 1200px;
   margin: auto;
}

.control-width{
    width: 600px;
}
.stage-box{
    height: 90px;
    width: 180px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover{
    background-color: #f1f1f1
}
.checked{
    position: absolute;
    left: 190px;
    font-size: 35px;
    bottom: 45px;
    color: #4BB38E;
}
.input-title{
    font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
    .stage-box{
        height:75px;
        width: 140px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }
    .checked{
        position: absolute;
        left: 135px;
        font-size: 30px;
        bottom: 45px;
        color: #4BB38E;
    }
}
</style>